import { mutatorAction } from 'satcheljs';
import { publicFolderFavoriteStore } from 'owa-public-folder-favorite';
/**
 * Mutator to add public folder in public folder favorite table for the deeplink view
 */
var loadPopoutDataToPublicFolderFavoriteStore = mutatorAction('loadPopoutDataToPublicFolderFavoriteStore', function (popoutData) {
    var folderId = popoutData.folderId, treeType = popoutData.treeType, replicaItem = popoutData.replicaItem;
    var folderTable = publicFolderFavoriteStore.folderTable;
    if (!folderTable.get(folderId)) {
        var folder = {
            FolderId: { Id: folderId },
            treeType: treeType,
            ReplicaList: [replicaItem],
        };
        folderTable.set(folderId, folder);
    }
});
export default loadPopoutDataToPublicFolderFavoriteStore;
//# sourceMappingURL=loadPopoutDataToPublicFolderFavoriteStore.js.map